import { Component } from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'lodash/isEqual';

export default class GeoJSON extends Component { // eslint-disable-line

  static contextTypes = {
    data: PropTypes.shape({
      type: PropTypes.string,
    }),
    map: PropTypes.object,
  };

  componentDidMount() {
    this.create();
  }

  shouldComponentUpdate(nextProps) {
    if (!deepEqual(nextProps.data, this.props.data)) {
      this.destroy();
      this.create(nextProps);
    }
    return false;
    //It's ok the return of shouldComponentUpdate to be false
    //We do not rely on it to “prevent” a rendering, as this can lead to bugs.
    //It's more a performance optimization, return true will work as well
  }

  componentWillUnmount() {
    this.destroy();
  }

  features = [];

  create(props = this.props) {
    let features = props.data;

    if (!props.data) return;

    if (
      props.data.type !== 'FeatureCollection' &&
      props.data.type !== 'Feature'
    ) {
      features = {
        type: 'Feature',
        geometry: props.data,
      };
    }
    this.features = this.context.map.data.addGeoJson(features);
  }

  destroy() {
    for (let i = 0; i < this.features.length; i++) {
      this.context.map.data.remove(this.features[i]);
      delete this.features[i];
    }
  }

  render() {
    return null;
  }
}
